import { topicsData } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">大家都在讨论的热门标签，点击探索更多精彩内容</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#ranking"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-300 cursor-pointer ${
                topic.hot
                  ? 'bg-accent-100 border-accent-300 hover:bg-accent-200'
                  : 'bg-background-100 border-background-200/70 hover:bg-background-200 hover:border-primary-200'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
              <span className={`text-sm font-medium whitespace-nowrap ${topic.hot ? 'text-accent-800' : 'text-foreground-700'}`}>
                {topic.name}
              </span>
              <span className={`text-xs ${topic.hot ? 'text-accent-600' : 'text-foreground-500'}`}>{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}